import React from "react";
const ModalServiceContext = React.createContext(
  null
);
export {
  ModalServiceContext
};
//# sourceMappingURL=ModalContext.js.map
